import { AddressDisplay, Typeahead } from '../../gs-component-form';
import { Content as RightRailContent, RouterContext } from '../../gs-component-right-rail';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { InlineAlert } from '@xo-union/tk-component-alerts';
import { Field as FormikField, FormikProps } from 'formik';
import React, { useContext } from 'react';

import { ErrorContext } from '../components/ErrorContext';
import { OptionalForm, EventVisibility } from '../components/Form';
import RightRailSection from '../components/RightRailSection';
import addressComponentParser, { LocalVendorValues } from '../helpers/addressComponentHelper';
import hasAddress from '../helpers/addressHelpers';
import { GoogleAddressValues } from '../helpers/objectifyGoogleAddressComponents';
import { EventInfoForm } from './EventInfoForm';
import { VenueForm } from './VenueForm';
import { EventsList } from './EventsList';
import { SoEInitialValues } from './ScheduleOfEventsForm';
import { LocationContext } from '../components/LocationContext';
import { AutoFocusableFields } from './interface';
import { VENUE } from './helpers';
import styles from './content.scss';

interface Props {
  hasWWS: boolean;
  formProps: FormikProps<SoEInitialValues>;
  autoFocusField: AutoFocusableFields | undefined;
  isExperiment?: boolean;
}

export const Content: React.FC<Props> = ({ hasWWS, formProps, autoFocusField, isExperiment }) => {
  const { setFieldValue, values, resetForm, initialValues } = formProps;
  const { push } = useContext(RouterContext);
  const { errors } = useContext(ErrorContext);

  const { setWeddingAddress } = useContext(LocationContext);

  const onChange = (addressComponentValues: GoogleAddressValues | LocalVendorValues, source: string): void => {
    const { vendor_name, gdsAddress, address_components, vendor_profile_id } = addressComponentParser(
      addressComponentValues,
      source
    );
    setFieldValue('location.zip', gdsAddress.zip);
    setFieldValue('location.city', gdsAddress.city);
    setFieldValue('location.state', gdsAddress.state);
    setFieldValue('location.country', gdsAddress.country);
    setFieldValue('location.street1', gdsAddress.street1);
    setFieldValue('location.name', vendor_name);

    setWeddingAddress({ vendor_name, address_components, vendor_profile_id });
  };

  const deleteEventLocation = (): void => {
    resetForm({
      values: {
        ...values,
        // @ts-ignore
        location: {
          zip: '',
          city: '',
          state: '',
          country: '',
          street1: '',
          name: '',
        },
      },
    });
  };

  const editCallback = (): void => push('customVendor');

  const renderVenue = () => {
    if (hasAddress(values.location)) {
      return (
        <FormBlockColumn>
          <AddressDisplay
            vendorType="Venue Name"
            data-testid="venue_name"
            deleteCallback={deleteEventLocation}
            editCallback={editCallback}
            {...values.location}
          />
        </FormBlockColumn>
      );
    }

    return (
      <FormBlockColumn>
        <FormikField
          name="location.name"
          label="Venue Name"
          data-testid="venue_name"
          onChange={onChange}
          component={Typeahead}
          onClickAddCustom={editCallback}
          allowCustomVendor
          autoFocus={autoFocusField === VENUE}
        />
      </FormBlockColumn>
    );
  };

  return (
    <RightRailContent className={styles.rightRailContent}>
      <RightRailSection name="Event Information">
        {errors && <InlineAlert type="error">{errors.unknown}</InlineAlert>}
        <EventInfoForm
          setFieldValue={setFieldValue}
          showHideDateCheckbox={!!initialValues.hideDate}
          autoFocusField={autoFocusField}
        />
        {!isExperiment ? renderVenue() : null}
        <OptionalForm />
      </RightRailSection>
      {isExperiment ? <VenueForm formProps={formProps} autoFocus={autoFocusField === VENUE} /> : null}
      <EventsList formProps={formProps} />
      <EventVisibility hasWWS={hasWWS} setFieldValue={setFieldValue} />
    </RightRailContent>
  );
};
